<template>
  <div class="signature-link-container">
    <a 
      href="https://mannmadecreations.co.uk" 
      target="_blank" 
      rel="noopener noreferrer"
      class="signature-link"
    >
      GET PIXEL PERFECTION
    </a>
  </div>
</template>

<script>
export default {
  name: 'DesktopSignature'
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap');

/* This entire component is hidden on mobile screens by default */
.signature-link-container {
  display: none;
}

/* On medium screens (768px) and up, it becomes visible and active */
@media (min-width: 768px) {
  .signature-link-container {
    display: block; /* Make it visible */
    position: fixed;
    bottom: 20px;
    left: 20px;
    z-index: 1000;
    transform: translateX(-150%);
    animation: slideInFromLeft 1.5s 1s ease-out forwards;
  }

  .signature-link {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    font-family: 'Press Start 2P', cursive;
    font-size: 12px;
    letter-spacing: 2px;
    text-decoration: none;
    padding: 12px 6px;
    color: #ffffff;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.6);
    transition: all 0.3s ease;
  }

  .signature-link:hover {
    transform: rotate(180deg) scale(1.05);
    text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
    color: #f0f8ff;
  }

  @keyframes slideInFromLeft {
    0% { transform: translateX(-150%); }
    100% { transform: translateX(0); }
  }
}
</style>